import React, { useEffect, useState, useRef } from 'react'
import styled from 'styled-components'
import Modal from 'react-modal'
import type { ComponentType } from 'react'
import ModalTitle from './modal/ModalTitle'
import ModalInner from './modal/ModalInner'
import ModalHeader from './modal/ModalHeader'
import ModalFooter from './modal/ModalFooter'
import ModalCloseButton from './modal/ModalCloseButton'
import modalStyles from './modal/modalStyles'

import AreaPanelButton from './areaSelectModal/AreaPanelButton'
import AreaBox from './areaSelectModal/AreaBox'
import SearchButton from '@pc/components/Works/Panel/shared/button/SearchButton'
import PanelButtonPopupIcon from './PanelButtonPopupIcon'
import WorksCount from '@pc/components/Works/Panel/shared/WorksCount'
import useWorksCount from '@pc/components/Works/Panel/hook/useWorksCount'
import { buildDynamicSearchApiUrl } from '@pc/components/Works/Panel/util/workSearchApi'
import type { SearchParamsAttributes, Prefecture } from '@pc/components/Works/Panel/type'

interface PropsType {
  params: SearchParamsAttributes
  prefecture: Prefecture
}

const AreaSearchControlBoxWrapper = styled.div`
  align-items: center;
  display: flex;
  justify-content: flex-end;
`

const GUIDE_AREA_URL = '/prefectures'

const ReactModal = Modal as unknown as ComponentType<any>

const el = document.querySelector<HTMLElement>('.js-works-search-panel')
if (el !== null) {
  Modal.setAppElement('.js-works-search-panel')
}

const AreaSelectModal = (props: PropsType) => {
  const { params, prefecture } = props

  const citiesAttr = el?.dataset.worksCities
  if (citiesAttr === undefined) return

  const cities: Prefecture[] = JSON.parse(citiesAttr).data

  const [modalIsOpen, setModalIsOpen] = useState(false)
  const [selectedCityIds, setSelectedCityIds] = useState<string[]>([])
  const { worksCount, updateCountFromParams } = useWorksCount()
  const renderFlgRef = useRef(false)

  const toggleModal = (e: React.MouseEvent<HTMLElement>) => {
    e.preventDefault()
    setModalIsOpen(!modalIsOpen)
  }

  const changeCityIds = (cityIds: string[]) => {
    setSelectedCityIds(cityIds)
  }

  const mergedParams = () => {
    // 地域系の検索の場合は路線・駅の条件をリセットする仕様になっている
    // 検索パネルの仕様上、prefectureを変更することができず情報を保持していると検索結果がおかしくなる可能性があるためリセット
    return { ...params, city_ids: selectedCityIds, line_ids: [], station_ids: [] }
  }

  useEffect(() => {
    if (renderFlgRef.current) {
      updateCountFromParams(mergedParams())
    } else {
      renderFlgRef.current = true
    }
  }, [selectedCityIds])

  useEffect(() => {
    const paramCityCompatIds = params.city_ids
    const selectedCityIds: string[] = cities
      .filter((city) => paramCityCompatIds?.includes(city.attributes.compat_id.toString()))
      .map((city) => city.attributes.compat_id.toString())
    setSelectedCityIds(selectedCityIds)
  }, [])

  return (
    <>
      <AreaPanelButton onClick={toggleModal}>
        エリア変更
        <PanelButtonPopupIcon />
      </AreaPanelButton>
      <ReactModal isOpen={modalIsOpen} onRequestClose={toggleModal} style={modalStyles}>
        <ModalInner>
          <ModalCloseButton onClick={toggleModal} />
          <ModalHeader>
            <ModalTitle>{prefecture.attributes.name}内のエリア変更</ModalTitle>
            <a href={GUIDE_AREA_URL}>都道府県を変更</a>
          </ModalHeader>
          <AreaBox prefecture={prefecture} cities={cities} selectedCityIds={selectedCityIds} changeCityIds={changeCityIds} />
          <ModalFooter>
            <AreaSearchControlBoxWrapper>
              <WorksCount count={worksCount} />
              <SearchButton searchUrl={buildDynamicSearchApiUrl(mergedParams())} />
            </AreaSearchControlBoxWrapper>
          </ModalFooter>
        </ModalInner>
      </ReactModal>
    </>
  )
}

export default AreaSelectModal
